import React from "react";

function TopPropertyCard({ card }) {
  return (
    <div className="relative mx-1 h-72 overflow-hidden rounded-2xl border border-slate-200/90 bg-slate-100 shadow-md ring-1 ring-black/[0.03] transition hover:shadow-lg md:ml-3 md:h-80">
      <img
        src={card.imgUrl}
        className="h-full w-full object-cover transition duration-500 hover:scale-[1.03]"
        alt={card.title || "Property preview"}
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0F172A]/85 via-[#0F172A]/25 to-transparent" />
      {card.title ? (
        <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
          <p className="line-clamp-2 text-sm font-semibold leading-snug text-white md:text-base">
            {card.title}
          </p>
          {card.description ? (
            <p className="mt-1 line-clamp-1 text-[11px] text-white/75 md:text-xs">
              {card.description}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default TopPropertyCard;
